// Front y API se sirven desde el mismo nginx: URL relativa (mismo origen).
export const environment = {
  production: false,
  environment: 'development',
  apiUrl: '',
  enableLogging: true,
  version: '1.0.0-dev',
};
